import SortOption from './SortOption';

export default Object.freeze({
  [SortOption.DEFAULT]: 'favourites_first',
  [SortOption.PRICE_ASC]: 'price_asc',
  [SortOption.PRICE_DESC]: 'price_desc',
  [SortOption.PRICE_PER_ASC]: 'price_per_asc',
  [SortOption.PRICE_PER_DESC]: 'price_per_desc',
  [SortOption.NAME_ASC]: 'name_asc',
  [SortOption.NAME_DESC]: 'name_desc',
  [SortOption.SHELF_LIFE]: 'shelf_life',
  [SortOption.CUSTOMER_RATING]: 'customer_rating',
});
